import {gql, useQuery} from "@apollo/client";
import {getFetchPolicyOptions} from "api/utils";
import {useGetLinkedContactInfo} from "../../../../api/common/useGetLinkedContactInfo";

const CONTACT_QUERY = gql`
    query GetContactRepresentees{
        contactsByParameters(parameters: {
            status: "A"
        }) {
            id
            name
            contactId
            status
            representativeCodesString
        }
    }
`;

export interface Contact {
  id: number;
  name: string;
  contactId: string;
  status: string;
  representativeCodesString: string;
}

export interface GetContactsQuery {
  contactsByParameters: Contact[];
}

export const useGetRepresentees = () => {
  const {data: linkedContact} = useGetLinkedContactInfo();

  const {loading, error, data} = useQuery<GetContactsQuery>(CONTACT_QUERY, {
    skip: !linkedContact?.contactId,
    ...getFetchPolicyOptions(`useGetRepresentees.${linkedContact?.contactId}`),
  });

  const directRepresentees = data?.contactsByParameters.filter(contact => contact.representativeCodesString?.includes(linkedContact?.contactId || ""));

  return {
    loading,
    error,
    directRepresentees: directRepresentees || [],
    allContacts: data?.contactsByParameters || []
  };
};
